export var CreativeMode;
(function (CreativeMode) {
    CreativeMode[CreativeMode["AnimatedCreative"] = 0] = "AnimatedCreative";
    CreativeMode[CreativeMode["ManageView"] = 1] = "ManageView";
    CreativeMode[CreativeMode["DesignView"] = 2] = "DesignView";
    CreativeMode[CreativeMode["ImageGenerator"] = 3] = "ImageGenerator";
    CreativeMode[CreativeMode["VideoGenerator"] = 4] = "VideoGenerator";
})(CreativeMode || (CreativeMode = {}));
